<template>
    <Admin
        :title="__('Site info', null, $page.props.profile_locale)"
    >

        <div class="grid lg:grid-cols-2 gap-3">
            <InputLabel
                id="address"
                type="textarea"
                :label="__('Address', null, $page.props.profile_locale)"
                v-model="form.site.address"
                autocomplete="address"
            />
            <InputLabel
                id="email"
                type="email"
                :label="__('Email', null, $page.props.profile_locale)"
                v-model="form.site.email"
                autocomplete="email"
            />
            <InputLabel
                id="phone"
                type="text"
                :label="__('Phone', null, $page.props.profile_locale)"
                v-model="form.site.phone"
                required
                autocomplete="phone"
            />
            <div class="grid col-start-1 gap-3">
                <InputLabel
                    id="phone"
                    type="text"
                    :label="__('Facebook', null, $page.props.profile_locale)"
                    v-model="form.social.facebook"
                />
                <InputLabel
                    id="phone"
                    type="text"
                    :label="__('YouTube', null, $page.props.profile_locale)"
                    v-model="form.social.youtube"
                />
                <InputLabel
                    id="phone"
                    type="text"
                    :label="__('Pinterest', null, $page.props.profile_locale)"
                    v-model="form.social.pinterest"
                />
            </div>
            <div class="flex justify-start col-span-full">
                <Button
                    color="gray"
                    padding="md"
                    @click="save()"
                >
                {{__('Update', null, $page.props.profile_locale)}}
                </Button>
            </div>
        </div>
    </Admin>
</template>

<script>
    import Admin from '@/Layouts/Admin';
    import Button from 'UI/Button';
    import SvgIcon from 'UI/SvgIcon';
    import InputLabel from 'UI/InputLabel';
    import { useForm } from '@inertiajs/inertia-vue3'


    export default {
        props: {
            options: [Array, Object],
        },
        components: {
            Admin, Button, SvgIcon, InputLabel
        },
        setup(props) {

            const form = useForm(props.options);

            if(!form.social){
                form.social = {
                    facebook: null,
                    youtube: null,
                    pinterest: null,
                }
            }

            function save(){
                form
                .transform((data) => ({
                    ...data,
                    social: form.social,
                }))
                .post(route('update.info'), {
                    preserveScroll: true,
                });
            }

            return {
                form,
                save,
            }
        },

    }
</script>
